import { apiRequest } from "@/services/api-client";
import { InventoryItemCardsOutput, WebAppRoutes } from "types/web-app";

export const listItemCards = () =>
  apiRequest<InventoryItemCardsOutput>("/" + WebAppRoutes.INVENTORY_ITEM_CARDS);
